import React from 'react';
import SectionHeader from './SectionHeader';

const ComparisonSection = ({
  sectionType,
  itemKey,
  zones,
  doc2Visibility,
  toggleDoc2Visibility,
  handleSectionExport,
  markAllCheckboxes,
  icon,
  tables
}) => {
  const sectionId = `${sectionType.charAt(0).toUpperCase() + sectionType.slice(1)} ${zones["Zone 1"]} vs. ${zones["Zone 2"]}`;
  
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        borderBottom: '2px solid rgb(0, 179, 181)',
        margin: '40px 0px 0px 0px',
        backgroundColor: '#ffffff',
        maxHeight: doc2Visibility[itemKey + `_${sectionType}`] ? '100px' : 'unset',
        overflowY: doc2Visibility[itemKey + `_${sectionType}`] ? 'hidden' : 'auto'
      }}
    >
      <SectionHeader 
        sectionType={sectionType}
        itemKey={itemKey}
        zones={zones}
        doc2Visibility={doc2Visibility}
        toggleDoc2Visibility={toggleDoc2Visibility}
        handleSectionExport={handleSectionExport}
        markAllCheckboxes={markAllCheckboxes}
        icon={icon}
        sectionId={sectionId}
      />
      
      {tables}
    </div>
  );
};

export default ComparisonSection;
